export { default } from './Tabs';
export * from './types';
